// @vue/component
import { projectUserAllMainDoctorApi } from "@/api/project_user";
import {
  subjectAddApi,
  subjectNextInforApi,
  getEDCProjectVersion,
  subjectUpdate,
  subjectEdit,
  subjectLoading,
} from "@/api/subjects";

export default {
  name: "Add",

  components: {},
  mixins: [],
  props: {
    project: {
      type: Object,
      require: true,
    },
    unit_list: {
      require: true,
    },
    is_disabled: Boolean,
    subjectInfo: Object,
    parameterList: Array,
  },
  data() {
    return {
      unit_id: "",
      msgBox: {
        unit_name: "",
        doctor: "",
      },
      cross_number: "",
      isLoading: false,
      doctor: "",
      name_abb: "",
      choice_code: "",
      random_code: "",
      _id: "",
      // 自动填入时间项目id列表
      autoFillTimeProjectList: [
        "668e4e2513df9997b87bfa70",
        "676384b0edae8fd8260d250a",
        "6729ad6bca8f15889334565a",
        "69d8a7787b5c78b72652cd07",
        "69dddf407b5c78b726532676",
        "6a8c0d435fe3c7165f4bbe26",
        "6acf2b18e344ebf0d38cedc5",
      ],
      main_doctor_list: [], // 主要研究者列表
      choice_code_prefix: "",
      choice_code_prefix_sep: "",
      random_code_prefix: "",
      random_code_prefix_sep: "",
      layer_dict: {},
      regTime: "", // 入组时间
      data_version: "",
      confirm: false, // 用来判断是否进行乐二次确认
      isUpdate: false,
      versionList: [],
      new_par_list: this.parameterList,
      layer_list: [],
      unit_code: null,
      envName: sessionStorage.getItem("iwrs_environment"),
      hideProjectList: [
        "62f9f0dcc43d533bd20f99a1",
        "62970c755a08ad1af5d3295f",
        "62b913e631c5eca8a702970d",
        "63734473ccd197d402a938fd",
        "64096d9e864ff9db7cee37c8",
        "6419275437a4507c1d49ab08",
        "64191c906e014b193a343f28",
        "6305b6ed048cec1f511d8e06",
        "6476bc96ad1ad354ffb4b15c",
        "64e843888dfa6a8de671cdff",
        "6513d5c49c140b4bd8c0ceb8",
        "6528e3569c140b4bd8c79dd7",
        "6593830598972b5989056c2b",
        "661892a3a5957e087c613555",
        "676a26d1e38a8ebcd771a00b",
        "691db272acc1e865824ab578",
        "69644ed3eef6c246fc90a406",
        "6976f995ae36518830df073a",
        "6a3dd4ec24f5db851d8016b9",
        "6a66c6715f164366b3de026c",
        "6aa222ac1c6db8088da6b552",
      ],
      UATHidProjectList: [
        "64191c906e014b193a343f28",
        "63db10fabbae4962a9dadbd2",
        "64096d9e864ff9db7cee37c8",
        "6419275437a4507c1d49ab08",
      ],
      projectDateMap: {
        "66cbf3c0fc0a6b41e1352826": "知情同意书签署日期",
        "63919eaef86d0682b94669fd": "签署知情时间",
        "63410c94eaea91a48060aeb8": "随机日期",
        "6476ce88d477c932cf3e17bf": "随机时间",
        "66c70559fc0a6b41e1351831": "随机时间",
        "6729ad6bca8f15889334565a": "随机时间",
        "678f3c9def2164132767c5c8": "签署知情时间",
        "67ede6da43107079f586f07b": "知情同意书签署时间",
        "6a3a51fa04ac36255ee907c3": "知情时间",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  computed: {
    showNumberStr() {
      if (
        [
          "62f9f0dcc43d533bd20f99a1",
          "6476bc96ad1ad354ffb4b15c",
          "69d8a7787b5c78b72652cd07",
        ].includes(this.project.id)
      ) {
        return "数字";
      }
      return "";
    },
  },
  watch: {
    subjectInfo: {
      handler(newV, oldV) {
        console.log(newV);
        if (newV.id) {
          if (this.project.id === "64a7761b890bc7b5059ee86a") {
            this.cross_number = newV.cross_number;
            this.regTime = newV.regTime;
          }
          this.unit_id = newV.unit_id;
          this.doctor = newV.doctor;
          this.unitChange(newV.unit_id);
          newV.new_parameter_list.forEach((i, index) => {
            this.new_par_list[index].new_parameter_value = i.value;
          });

          this.name_abb = newV.name_abb;
          this.layer_dict = newV.layer_dict;
          this.choice_code = newV.choice_code;
          this.random_code = newV.random_code;
          this.data_version = newV.data_version;
          //
          // this.regTime = newV.regTime;
          this._id = newV.id;
          this.isUpdate = true;
        } else {
          this.new_par_list.forEach((item) => {
            item["new_parameter_value"] = "";
          });
          this.unit_id = "";
          this.doctor = "";
          this.name_abb = "";
          this.layer_dict = {};
          this.choice_code = "";
          this.random_code = "";
          this.cross_number = "";
          this.data_version = "";
          this.regTime = "";
          this._id = "";
          this.isUpdate = false;
        }
      },
      immediate: true,
      // deep: true
    },
  },

  created() {
    // console.log(this.project);
    // this.layer_list=this.project.
    this.getVersion();
    // 当前日期
    var day2 = new Date();
    day2.setTime(day2.getTime());
    if (
      this.project.is_fix_in_group_time ||
      this.autoFillTimeProjectList.includes(this.project.id)
    ) {
      this.regTime =
        day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate();
    }
    // 制定项目默认选择中心及研究者
    if (
      this.project.id === "64a7761b890bc7b5059ee86a" &&
      this.unit_list.length === 1
    ) {
      this.unit_id = this.unit_list[0].id;
      this.unitChange(this.unit_list[0].id);
    }
  },
  methods: {
    handleNumberInput(value, name) {
      // 特定项目限制数字的
      if (this.showNumberStr) {
        this[name] = value.replace(/[^\d]/g, "");
      }
    },
    getVersion() {
      getEDCProjectVersion({ project_id: this.project.id }).then((res) => {
        this.versionList = res.data;
      });
    },
    unitChange(id) {
      this.doctor = this.unit_list.find((item) => {
        return item.id === id;
      }).doctor;
      const result = this.unit_list.find((item) => {
        return item.id === id;
      });
      this.unit_code = result.code;
      this.msgBox.unit_name = result.value;
      this.msgBox.doctor = result.doctor;
    },
    //
    async goSubmit() {
      // 请求参数
      let params = {
        project_id: this.project.id,
        unit_id: this.unit_id,
        doctor: this.doctor,
        name_abb: this.name_abb,
        layer_dict: this.layer_dict,
        choice_code: this.choice_code,
        data_version: this.data_version,
        random_code: this.random_code,
        regTime: this.moment(this.regTime).format("YYYY-MM-DD"),
        new_parameter_list: this.new_par_list,
      };

      // 确认随机
      if (this.isUpdate) {
        if (this.project.id === "64a7761b890bc7b5059ee86a") {
          params = {
            cross_number: this.cross_number,
            name_abb: this.name_abb,
            regTime: this.moment(this.regTime).format("YYYY-MM-DD"),
            project_id: this.project.id,
          };
        }
        this.isLoading = true;
        const loading = this.$loading({
          lock: true,
          text: "随机中，请勿关闭/刷新此页面",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
          customClass: "loadingBox_",
        });
        if (this.project.id === "64a7761b890bc7b5059ee86a") {
          subjectEdit({ ...params, id: this._id })
            .then((res) => {
              if (res && res.success) {
                this.$emit("ok");
                this.$message.success("编辑成功");
                // 数据初始化
                this.unit_id = "";
                this.doctor = "";
                this.name_abb = "";
                this.layer_dict = {};
                this.regTime = "";
                this.choice_code = "";
                this.random_code = "";
                this.data_version = "";
                this.new_par_list.forEach((item) => {
                  item["new_parameter_value"] = "";
                });
              } else {
                this.$message.error(res.msg);
              }
            })
            .finally(() => {
              this.isLoading = false;
              loading.close();
            });
        } else {
          subjectUpdate({ ...params, id: this._id })
            .then((res) => {
              if (res && res.success) {
                this.$emit("ok");
                this.$message.success("入组成功");
                // 数据初始化
                this.unit_id = "";
                this.doctor = "";
                this.name_abb = "";
                this.layer_dict = {};
                this.regTime = "";
                this.choice_code = "";
                this.random_code = "";
                this.data_version = "";
                this.new_par_list.forEach((item) => {
                  item["new_parameter_value"] = "";
                });
              } else {
                this.$message.error(res.msg);
              }
            })
            .finally(() => {
              this.isLoading = false;
              loading.close();
            });
        }
      } else {
        if (this.project.id === "64a7761b890bc7b5059ee86a") {
          params["cross_number"] = this.cross_number;
        }
        const confirmIds = [
          "6375a10b1850609bca8a048f",
          "63734473ccd197d402a938fd",
          "68c38289790bb3b4a6d16747",
        ];
        // 需要二次弹窗
        if (
          confirmIds.includes(this.project.id) ||
          (this.UATHidProjectList.includes(this.project.id) &&
            this.envName === "UAT")
        ) {
          const arr = Object.keys(this.layer_dict);
          let layetStr = "";
          if (arr.length) {
            arr.forEach((i) => {
              const obj = this.project.layer_list.find((j) => j.id === i);
              const item = obj.item_list.find(
                (k) => k.id === this.layer_dict[i]
              );
              layetStr += `<p>${obj.name}：${item.name}</p>`;
            });
          }
          const str = `
          <p>中心：${this.msgBox.unit_name}</p>
          <p>主要研究者：${this.msgBox.doctor}</p>
          <p>${this.project.initials_another_name}：${this.name_abb}</p>
          ${
            !this.project.is_choice_code_system
              ? `<p>${this.project.choice_code_another_name}：${
                  this.choice_code_prefix +
                  this.unit_code +
                  this.choice_code_prefix_sep +
                  this.choice_code
                }</p>`
              : ``
          }
          ${
            !this.project.is_random_code_system
              ? `<p>${this.project.random_code_another_name}：${
                  this.random_code_prefix +
                  this.unit_code +
                  this.random_code_prefix_sep +
                  this.random_code
                }</p>`
              : ``
          }
          ${layetStr || ""}
          ${
            !this.hideProjectList.includes(this.project.id)
              ? `${this.project.in_group_time_name}：${this.moment(
                  this.regTime
                ).format("YYYY-MM-DD")}`
              : ""
          }
          `;
          this.$alert(str, "是否确认随机", {
            dangerouslyUseHTMLString: true,
            showCancelButton: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }).then(() => {
            this.isLoading = true;
            const loading = this.$loading({
              lock: true,
              text: "随机中，请勿关闭/刷新此页面",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
              customClass: "loadingBox_",
            });
            subjectAddApi(params, this.project.id)
              .then((res) => {
                if (res && res.success) {
                  this.$emit("ok");
                  this.$message.success("入组成功");
                  this.unit_id = "";
                  this.doctor = "";
                  this.name_abb = "";
                  this.layer_dict = {};
                  this.choice_code = "";
                  this.random_code = "";
                  this.data_version = "";
                  this.new_par_list.forEach((item) => {
                    item["new_parameter_value"] = "";
                  });
                } else {
                  this.$message.error(res.msg);
                }
              })
              .finally(() => {
                this.isLoading = false;
                loading.close();
              });
          });
        } else {
          this.isLoading = true;
          const loading = this.$loading({
            lock: true,
            text: "随机中，请勿关闭/刷新此页面",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
            customClass: "loadingBox_",
          });
          subjectAddApi(params, this.project.id)
            .then((res) => {
              if (res && res.success) {
                this.$emit("ok");
                this.$message.success("入组成功");
                this.unit_id = "";
                this.doctor = "";
                this.name_abb = "";
                this.layer_dict = {};
                this.choice_code = "";
                this.random_code = "";
                this.data_version = "";
                this.new_par_list.forEach((item) => {
                  item["new_parameter_value"] = "";
                });
              } else {
                this.$message.error(res.msg);
              }
            })
            .finally(() => {
              this.isLoading = false;
              loading.close();
            });
        }
      }
    },
    // goAdd() {
    //   // 提交登记受试者的请求
    //   const params = {
    //     project_id: this.project.id,
    //     unit_id: this.unit_id,
    //     doctor: this.doctor,
    //     name_abb: this.name_abb,
    //     layer_dict: this.layer_dict,
    //     choice_code: this.choice_code,
    //     data_version: this.data_version,
    //     random_code: this.random_code,
    //     regTime: this.moment(this.regTime).format("YYYY-MM-DD"),
    //     new_parameter_list: this.new_par_list
    //   };
    //   this.isLoading  = true;
    //   // console.log(this.new_par_list);
    //   if (this.isUpdate) {
    //     subjectUpdate({ ...params, id: this._id })
    //       .then(res => {
    //         if (res && res.success) {
    //           //数据初始化
    //           this.unit_id = "";
    //           this.doctor = "";
    //           this.name_abb = "";
    //           this.layer_dict = {};
    //           this.choice_code = "";
    //           this.random_code = "";
    //           this.data_version = "";
    //           this.new_par_list.forEach(item => {
    //             item["new_parameter_value"] = "";
    //           });
    //           this.$emit("ok");
    //         } else {

    //           this.$message.error(res.msg);
    //         }
    //       }).finally(() =>{
    //         this.isLoading = false;
    //       })
    //   } else {
    //     // if(!this.unit_id||!this.name_abb||!(this.project.is_choice_code_system||this.choice_code)||!(this.project.is_random_code_system||this.random_code)||!(this.hideProjectList.includes(this.project.id)||this.regTime)){
    //     //   return this.confirm=true;
    //     // }
    //     let arr = Object.keys(this.layer_dict);
    //     let layetStr = '';
    //     if(arr.length){
    //       arr.forEach(i =>{
    //         let obj = this.project.layer_list.find(j => j.id===i)
    //         let item = obj.item_list.find(k => k.id=== this.layer_dict[i])
    //         layetStr += `<p>${obj.name}：${item.name}</p>`
    //       })
    //     }
    //     let ids = ['6375a10b1850609bca8a048f','63734473ccd197d402a938fd']
    //     if(ids.includes(this.project.id)||(this.UATHidProjectList.includes(this.project.id)&&this.envName==='UAT')){
    //       let str = `
    //       <p>中心：${this.msgBox.unit_name}</p>
    //       <p>主要研究者：${this.msgBox.doctor}</p>
    //       <p>${this.project.initials_another_name}：${this.name_abb}</p>
    //       ${!this.project.is_choice_code_system?`<p>${this.project.choice_code_another_name}：${this.choice_code_prefix+this.unit_code+this.choice_code_prefix_sep+this.choice_code}</p>`:``}
    //       ${!this.project.is_random_code_system?`<p>${this.project.random_code_another_name}：${this.random_code_prefix+this.unit_code+this.random_code_prefix_sep+this.random_code}</p>`:``}
    //       ${layetStr||''}
    //       ${!this.hideProjectList.includes(this.project.id)?`${this.project.in_group_time_name}：${this.moment(this.regTime).format("YYYY-MM-DD")}`:''}
    //       `
    //       // if(this.project.layer_list.length){
    //       //   this.project.layer_list.forEach(i =>{
    //       //     str += `<p>${i.name}：${this.layer_dict[i.id]}</p>`
    //       //   })
    //       // }
    //       this.$alert(str, '是否确认随机', {
    //       dangerouslyUseHTMLString: true,
    //       showCancelButton: true,
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //     }).then(() =>{
    //       subjectAddApi(params).then(res =>{
    //         if(res && res.success){
    //           this.unit_id = "";
    //           this.doctor = "";
    //           this.name_abb = "";
    //           this.layer_dict = {};
    //           this.choice_code = "";
    //           this.random_code = "";
    //           this.data_version = "";
    //           this.new_par_list.forEach(item => {
    //             item["new_parameter_value"] = "";
    //           });
    //           this.$emit("ok");
    //         }else{
    //           this.$message.error(res.msg);
    //         }
    //       }).finally(() =>{
    //         this.isLoading = false;
    //       })
    //     })
    //     }else{
    //       subjectAddApi(params).then(res =>{
    //         if(res && res.success){
    //           this.unit_id = "";
    //           this.doctor = "";
    //           this.name_abb = "";
    //           this.layer_dict = {};
    //           this.choice_code = "";
    //           this.random_code = "";
    //           this.data_version = "";
    //           this.new_par_list.forEach(item => {
    //             item["new_parameter_value"] = "";
    //           });
    //           this.$emit("ok");
    //         }else{
    //           this.$message.error(res.msg);
    //         }
    //       }).finally(() =>{
    //         this.isLoading = false;
    //       })
    //     }

    //   }
    // }
  },
};
